import get from 'lodash/get'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import setQuery from 'set-query-string'
import { getTotalGuests, parseQuery } from '../../../../utils'

export default function useCheckoutDrData(
  dueNowData,
  slug,
  shopTitle,
  rating,
  numberOfReviews,
  shopPicture,
  shopLocationTitle,
  selectedTripData,
  isFixedPackage,
  packagePrice,
  shopLocationSlug,
) {
  const orderDetails = useSelector((state) => ({
    dateFrom: get(state, 'departureDate.dateFrom'),
    dateTo: get(state, 'departureDate.dateTo'),
    duration: get(state, 'departureDate.duration'),
    guestsInRoom: get(state, 'guestsInRoom', {}),
    pax: getTotalGuests(get(state, 'guestsInRoom', {})),
  }))
  const diving = useSelector((state) =>
    get(state, 'checkoutInclusions.diverInclusions', {}),
  )
  const shopData = useMemo(() => {
    const query = parseQuery() || {}
    const roomDetails = get(orderDetails, 'guestsInRoom.details', [])
    const queryParams = {
      rate: selectedTripData.rate,
      room: selectedTripData.selectedRoom.id,
      mealPlan: selectedTripData.mealPlan,
      packages: selectedTripData.packages,
      roomParams: JSON.stringify(orderDetails.guestsInRoom),
      dateFrom: orderDetails.dateFrom,
      dateTo: orderDetails.dateTo,
      savedOrder: true,
      aid: query.aid,
    }
    dueNowData.selectedInclusions.forEach((item) => {
      if(item.diverNumber) {
        /* eslint-disable standard/computed-property-even-spacing */
        queryParams[
          `incl_${item.pricing}_${item.diverNumber - 1}_${item.guestType}`
        ] = item.quantity
      } else if(item.divingItem) {
        /* eslint-disable standard/computed-property-even-spacing */
        queryParams[
          `diving_${item.pricing}_${item.key}_${item.numberOfInstances}`
        ] = item.quantity
      } else if(!item.isRoom) {
        queryParams[`incl_${item.pricing}`] = item.quantity
      }
    })
    setQuery(queryParams, { clear: true })
    return {
      shopKind: 20,
      shopSlug: slug,
      shopTitle: shopTitle,
      rate: rating,
      numberOfReviews,
      thumbnails: {
        DOSliderMobileLand: shopPicture,
      },
      isDynamicPackages: !isFixedPackage,
      diveType: selectedTripData.diveType,
      packageDiveKind: selectedTripData.packageDiveKind,
      shopLocationTitle,
      divers: orderDetails.guestsInRoom.divers,
      nonDivers: orderDetails.guestsInRoom.nonDivers,
      students: orderDetails.guestsInRoom.students,
      orderDetails: {
        accomodation: roomDetails,
      },
      ...dueNowData,
      totalPackagePrice: packagePrice,
      dives: diving,
      divesInfo: {
        totalDives: isFixedPackage
          ? selectedTripData.divesAmount * orderDetails.guestsInRoom.divers
          : Object.values(diving).reduce((acc, item) => {
            acc += item.numberOfInstances
            return acc
          }, 0),
      },
      rooms: {
        quantity: roomDetails.length,
        title: selectedTripData.roomTitle,
        mealPlan: selectedTripData.mealPlan,
      },
      insurances: selectedTripData.insurances,
      shopLocationSlug,
    }
  }, [selectedTripData, shopPicture, orderDetails, dueNowData])

  return {
    orderDetails,
    shopData,
  }
}
